import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import { Popup, Field, Dialog, Picker } from 'vant'

import '@/assets/scss/common.scss'
import './plugins/element.js'

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Dialog)
Vue.use(Picker)

const switchlang = (navigator.language || navigator.browserLanguage).toLowerCase()

const i18n = new VueI18n({
  silentFallbackWarn: true,
  locale: switchlang,
  fallbackLocale: 'en',
  messages: {
    zh: require('./lang/zh-CN').default,
    'zh-cn': require('./lang/zh-CN').default,
    en: require('./lang/en-US').default,
    'en-us': require('./lang/en-US').default,
    'zh-hk': require('./lang/zh-TW').default,
    'zh-tw': require('./lang/zh-TW').default
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
